export const isNull = val => typeof val === 'object' && !val;
export const isDeclared = val => typeof val !== 'undefined' && !isNull(val);
